import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: "O CalculaDP é 100% online?",
      answer: "Sim! O CalculaDP funciona 100% online. Você pode acessar de qualquer lugar, a qualquer hora, usando computador, tablet ou celular. Basta ter internet e um navegador."
    },
    {
      question: "O sistema faz cálculos de horas noturnas e horas não trabalhadas?",
      answer: "Sim! O sistema foi desenvolvido para ser intuitivo. Você só precisa inserir os dados do funcionário e o sistema faz todos os cálculos automaticamente, seguindo a legislação vigente."
    },
    {
      question: "Posso usar em várias empresas?",
      answer: "Sim! Com uma única conta você pode cadastrar e gerenciar várias empresas. Ideal para contadores, departamento pessoal e gestores de rh que atendem muitos clientes clientes."
    },
    {
      question: "Os relatórios ficam salvos?",
      answer: "Todos os cálculos e relatórios ficam salvos no seu histórico. Você pode acessar, reimprimir e consultar qualquer cálculo já feito a qualquer momento."
    },
    {
      question: "Tem suporte técnico?",
      answer: "Sim! Oferecemos suporte por WhatsApp e email. Nossa equipe tem experiência em DP e está pronta para te ajudar."
    },
    {
      question: "É atualizado com as mudanças legais?",
      answer: "Sempre! O sistema é automaticamente atualizado sempre que há mudanças na legislação trabalhista. Você não precisa se preocupar com isso."
    },
    {
      question: "Como funciona a garantia de 7 dias?",
      answer: "Simples! Você poderá testar todas as funcionalidades. Se não ficar satisfeito por qualquer motivo, devolvemos 100% do valor pago, sem perguntas. Basta enviar uma mensagem no WhatsApp do suporte."
    },
    {
      question: "Posso cancelar a qualquer momento?",
      answer: "Claro! Não há fidelidade. Você pode cancelar quando quiser e continuará tendo acesso até o final do período já pago."
    },
    {
      question: "Como faço para personalizar com minha logo?",
      answer: "É muito fácil! Nas configurações, você poderá fazer upload da sua logo. Ela aparecerá automaticamente nos relatórios PDF que você gerar(é opcional)."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 md:py-32 px-4 bg-gray-50">
      <div className="container mx-auto max-w-4xl">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6">
            <span className="bg-teal-600 text-white px-4 py-2 rounded-lg">Dúvidas</span> Frequentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tire todas as suas dúvidas sobre o CalculaDP
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white rounded-2xl border border-gray-200 shadow-sm hover:shadow-md transition-all"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 rounded-2xl transition-colors"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`transform transition-transform ${
                  openIndex === index ? 'rotate-180' : ''
                }`}>
                  <i className="ri-arrow-down-s-line text-2xl text-gray-600"></i>
                </div>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <div className="border-t pt-4">
                    <p className="text-gray-600 leading-relaxed">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA após FAQ */}
        <div className="text-center mt-16 bg-gradient-to-r from-teal-50 to-cyan-50 rounded-3xl p-8 md:p-12 border border-teal-100">
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Ainda tem dúvidas?
          </h3>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            Nossa equipe de suporte está pronta para te ajudar com qualquer questão
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-3 rounded-xl font-bold transition-colors whitespace-nowrap">
              <i className="ri-chat-3-line mr-2"></i>
              Falar com Suporte
            </button>
            <a 
              href="https://youtu.be/OXYkNE7-8d0?list=TLGGAsc7OKyLIvQyNDAxMjAyNg"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white hover:bg-gray-50 text-teal-600 px-8 py-3 rounded-xl font-bold border-2 border-teal-600 transition-colors whitespace-nowrap inline-flex items-center justify-center"
            >
              <i className="ri-play-circle-line mr-2"></i>
              Assistir Demo
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
